export default __webpack_public_path__ + "static/media/How it works light.8e74ed4a.svg";